import React , {useEffect} from 'react';
import { Box, Tooltip, IconButton } from '@mui/material';
import PublishIcon from '@mui/icons-material/Publish';
import DataObjectIcon from '@mui/icons-material/DataObject';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import DeleteIcon from '@mui/icons-material/Delete';

const ActionToolbar = ({
  handlePublishForm,
  handleViewJSON,
  handleView,
  handleEdit,
  handleAssignGroup,
  openDeleteModal,
  data,
  isOnlyReadAccess,
}) => {

   useEffect(() => {
    console.log("isOnlyReadAccess: ", isOnlyReadAccess);
   }, [])
  return (
<Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
  {/* Publish Forms - Only if isOnlyReadAccess is false */}
  { !isOnlyReadAccess && (
    <Tooltip title="Publish Forms">
      <IconButton
        sx={{ color: '#2b4252', p: '2px' }}
        aria-label="view"
        onClick={() => handlePublishForm(data || null)}
      >
        <PublishIcon />
      </IconButton>
    </Tooltip>
  )}

  {/* View JSON - Always Visible */}
  { !isOnlyReadAccess && (
    <Tooltip title="View JSON">
      <IconButton
        sx={{ color: '#2b4252', p: '2px' }}
        aria-label="view-json"
        onClick={() => handleViewJSON(data || null)}
      >
        <DataObjectIcon />
      </IconButton>
    </Tooltip>
  )}

  {/* View - Always Visible */}
  { !isOnlyReadAccess && (
    <Tooltip title="View">
      <IconButton
        sx={{ p: '2px' }}
        aria-label="view"
        onClick={() => handleView(data || null)}
      >
        <VisibilityIcon />
      </IconButton>
    </Tooltip>
  )}

  {/* Edit - Only if isOnlyReadAccess is false */}
  { !isOnlyReadAccess && (
    <Tooltip title="Edit">
      <IconButton
        sx={{ color: '#2b4252', p: '2px' }}
        aria-label="edit"
        onClick={() => handleEdit(data || null)}
      >
        <EditIcon />
      </IconButton>
    </Tooltip>
  )}

  {/* Assign Group - Only if isOnlyReadAccess is false */}
  { !isOnlyReadAccess && (
    <Tooltip title="Assign Group">
      <IconButton
        sx={{ color: '#2b4252', p: '2px' }}
        aria-label="assign-group"
        onClick={() => handleAssignGroup(data || null)}
      >
        <WorkspacesIcon />
      </IconButton>
    </Tooltip>
  )}

  {/* Delete - Only if isOnlyReadAccess is false */}
  { !isOnlyReadAccess && (
    <Tooltip title="Delete">
      <IconButton
        sx={{ color: '#CC3824', p: '2px' }}
        aria-label="delete"
        onClick={() => openDeleteModal(data || null)}
      >
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  )}
</Box>

  );
};

export default ActionToolbar;
